// Images
import Image52 from "../images/billboards/52.webp";
import Image53 from "../images/billboards/53.webp";
import Image000 from "../images/billboards/Image000.webp";
import Image005 from "../images/billboards/Image005.webp";
import Image300 from "../images/billboards/300.webp";
import Image301 from "../images/billboards/301.webp";
import Image302 from "../images/billboards/302.webp";
import Image303 from "../images/billboards/303.webp";
import Image304 from "../images/billboards/304.webp";
import Image305 from "../images/billboards/305.webp";
import Image306 from "../images/billboards/306.webp";
import Image307 from "../images/billboards/307.webp";
import Image308 from "../images/billboards/308.webp";
import Image309 from "../images/billboards/309.webp";
import Image310 from "../images/billboards/310.webp";
import Image311 from "../images/billboards/311.webp";
import Image312 from "../images/billboards/312.webp";
import Image011 from "../images/billboards/Image011.webp";
import Image012 from "../images/billboards/Image012.webp";
import Image02 from "../images/billboards/Image02.webp";
import Image061 from "../images/billboards/Image061.webp";
import Image062 from "../images/billboards/Image062.webp";
import Image081 from "../images/billboards/Image081.webp";
import Image082 from "../images/billboards/Image082.webp";
import Image101 from "../images/billboards/Image101.webp";
import Image102 from "../images/billboards/Image102.webp";
import Image121 from "../images/billboards/Image121.webp";
import Image191 from "../images/billboards/Image191.webp";
import Image192 from "../images/billboards/Image192.webp";
import Image261 from "../images/billboards/Image261.webp";
import Image262 from "../images/billboards/Image262.webp";
import Image391 from "../images/billboards/Image391.webp";
import Image392 from "../images/billboards/Image392.webp";
import Image401 from "../images/billboards/Image401.webp";
import Image402 from "../images/billboards/Image402.webp";
import Image441 from "../images/billboards/Image441.webp";
import Image442 from "../images/billboards/Image442.webp";
import Image471 from "../images/billboards/Image471.webp";
import Image472 from "../images/billboards/Image472.webp";
import Image481 from "../images/billboards/Image481.webp";
import Image482 from "../images/billboards/Image482.webp";
import Image501 from "../images/billboards/Image501.webp";
import Image502 from "../images/billboards/Image502.webp";
import Image511 from "../images/billboards/Image511.webp";
import Image512 from "../images/billboards/Image512.webp";
import Image521 from "../images/billboards/Image521.webp";
import Image522 from "../images/billboards/Image522.webp";
import Image531 from "../images/billboards/Image531.webp";
import Image532 from "../images/billboards/Image532.webp";
import Image561 from "../images/billboards/Image561.webp";
import Image562 from "../images/billboards/Image562.webp";
import Image571 from "../images/billboards/Image571.webp";
import Image572 from "../images/billboards/Image572.webp";
import Image591 from "../images/billboards/Image591.webp";
import Image592 from "../images/billboards/Image592.webp";
import Image611 from "../images/billboards/Image611.webp";
import Image612 from "../images/billboards/Image612.webp";
import Image641 from "../images/billboards/Image641.webp";
import Image642 from "../images/billboards/Image642.webp";
import Image661 from "../images/billboards/Image661.webp";
import Image662 from "../images/billboards/Image662.webp";
import Image721 from "../images/billboards/Image721.webp";
import Image722 from "../images/billboards/Image722.webp";
import Image751 from "../images/billboards/Image751.webp";
import Image752 from "../images/billboards/Image752.webp";
import Image021 from "../images/billboards/Image021.webp";
import Image022 from "../images/billboards/Image022.webp";
import Image051 from "../images/billboards/Image051.webp";
import Image052 from "../images/billboards/Image052.webp";
import Image031 from "../images/billboards/Image031.webp";
import Image032 from "../images/billboards/Image032.webp";
import Image011DOS from "../images/billboards/Image011DOS.webp";
import Image012DOS from "../images/billboards/Image012DOS.webp";
import Image061DOS from "../images/billboards/Image061DOS.webp";
import Image062DOS from "../images/billboards/Image062DOS.webp";
import Image071DOS from "../images/billboards/Image071DOS.webp";
import Image072DOS from "../images/billboards/Image072DOS.webp";
import Image101DOS from "../images/billboards/Image101DOS.webp";
import Image102DOS from "../images/billboards/Image102DOS.webp";
import Image121DOS from "../images/billboards/Image121DOS.webp";
import Image122 from "../images/billboards/Image122.webp";
import Image111 from "../images/billboards/Image111.webp";
import Image112 from "../images/billboards/Image112.webp";

// Pdfs
import MARK_HMO_000_PDF from "../pdfs/MARK-HMO-000.pdf";
import PKM_HMO_005_PDF from "../pdfs/PKM-HMO-005.pdf";
import MARK_HMO_52_PDF from "../pdfs/MARK-HMO-52.pdf";
import MARK_HMO_53_PDF from "../pdfs/MARK-HMO-53.pdf";
import MARK_HMO_300_PDF from "../pdfs/MARK-HMO-300.pdf";
import MARK_HMO_301_PDF from "../pdfs/MARK-HMO-301.pdf";
import MARK_HMO_302_PDF from "../pdfs/MARK-HMO-302.pdf";
import MARK_HMO_303_PDF from "../pdfs/MARK-HMO-303.pdf";
import MARK_HMO_304_PDF from "../pdfs/MARK-HMO-304.pdf";
import MARK_HMO_305_PDF from "../pdfs/MARK-HMO-305.pdf";
import MARK_HMO_306_PDF from "../pdfs/MARK-HMO-306.pdf";
import MARK_SNP_307_PDF from "../pdfs/MARK-SNP-307.pdf";
import MARK_SNP_308_PDF from "../pdfs/MARK-SNP-308.pdf";
import MARK_HMO_309_PDF from "../pdfs/MARK-HMO-309.pdf";
import MARK_HMO_310_PDF from "../pdfs/MARK-HMO-310.pdf";
import MARK_HMO_311_PDF from "../pdfs/MARK-HMO-311.pdf";
import MARK_HMO_312_PDF from "../pdfs/MARK-HMO-312.pdf";
import E01_HMO_01_1_PDF from "../pdfs/E01-HMO-01-1.pdf";
import E01_HMO_01_2_PDF from "../pdfs/E01-HMO-01-2.pdf";
import E01_HMO_02_PDF from "../pdfs/E01-HMO-02.pdf";
import E01_HMO_06_1_PDF from "../pdfs/E01-HMO-06-1.pdf";
import E01_HMO_06_2_PDF from "../pdfs/E01-HMO-06-2.pdf";
import E01_HMO_08_1_PDF from "../pdfs/E01-HMO-08-1.pdf";
import E01_HMO_08_2_PDF from "../pdfs/E01-HMO-08-2.pdf";
import E01_HMO_10_1_PDF from "../pdfs/E01-HMO-10-1.pdf";
import E01_HMO_10_2_PDF from "../pdfs/E01-HMO-10-2.pdf";
import E01_HMO_12_1_PDF from "../pdfs/E01-HMO-12-1.pdf";
import E01_HMO_19_1_PDF from "../pdfs/E01-HMO-19-1.pdf";
import E01_HMO_19_2_PDF from "../pdfs/E01-HMO-19-2.pdf";
import E01_HMO_26_1_PDF from "../pdfs/E01-HMO-26-1.pdf";
import E01_HMO_26_2_PDF from "../pdfs/E01-HMO-26-2.pdf";
import E01_HMO_39_1_PDF from "../pdfs/E01-HMO-39-1.pdf";
import E01_HMO_39_2_PDF from "../pdfs/E01-HMO-39-2.pdf";
import E01_HMO_40_1_PDF from "../pdfs/E01-HMO-40-1.pdf";
import E01_HMO_40_2_PDF from "../pdfs/E01-HMO-40-2.pdf";
import E01_HMO_44_1_PDF from "../pdfs/E01-HMO-44-1.pdf";
import E01_HMO_44_2_PDF from "../pdfs/E01-HMO-44-2.pdf";
import E01_HMO_47_1_PDF from "../pdfs/E01-HMO-47-1.pdf";
import E01_HMO_47_2_PDF from "../pdfs/E01-HMO-47-2.pdf";
import E01_HMO_48_1_PDF from "../pdfs/E01-HMO-48-1.pdf";
import E01_HMO_48_2_PDF from "../pdfs/E01-HMO-48-2.pdf";
import E01_HMO_50_1_PDF from "../pdfs/E01-HMO-50-1.pdf";
import E01_HMO_50_2_PDF from "../pdfs/E01-HMO-50-2.pdf";
import E01_HMO_51_1_PDF from "../pdfs/E01-HMO-51-1.pdf";
import E01_HMO_51_2_PDF from "../pdfs/E01-HMO-51-2.pdf";
import E01_HMO_52_1_PDF from "../pdfs/E01-HMO-52-1.pdf";
import E01_HMO_52_2_PDF from "../pdfs/E01-HMO-52-2.pdf";
import E01_HMO_53_1_PDF from "../pdfs/E01-HMO-53-1.pdf";
import E01_HMO_53_2_PDF from "../pdfs/E01-HMO-53-2.pdf";
import E01_HMO_56_1_PDF from "../pdfs/E01-HMO-56-1.pdf";
import E01_HMO_56_2_PDF from "../pdfs/E01-HMO-56-2.pdf";
import E01_HMO_57_1_PDF from "../pdfs/E01-HMO-57-1.pdf";
import E01_HMO_57_2_PDF from "../pdfs/E01-HMO-57-2.pdf";
import E01_HMO_59_1_PDF from "../pdfs/E01-HMO-59-1.pdf";
import E01_HMO_59_2_PDF from "../pdfs/E01-HMO-59-2.pdf";
import E01_HMO_61_1_PDF from "../pdfs/E01-HMO-61-1.pdf";
import E01_HMO_61_2_PDF from "../pdfs/E01-HMO-61-2.pdf";
import E01_HMO_64_1_PDF from "../pdfs/E01-HMO-64-1.pdf";
import E01_HMO_64_2_PDF from "../pdfs/E01-HMO-64-2.pdf";
import E01_HMO_66_1_PDF from "../pdfs/E01-HMO-66-1.pdf";
import E01_HMO_66_2_PDF from "../pdfs/E01-HMO-66-2.pdf";
import E01_HMO_72_1_PDF from "../pdfs/E01-HMO-72-1.pdf";
import E01_HMO_72_2_PDF from "../pdfs/E01-HMO-72-2.pdf";
import E01_HMO_75_1_PDF from "../pdfs/E01-HMO-75-1.pdf";
import E01_HMO_75_2_PDF from "../pdfs/E01-HMO-75-2.pdf";
import E01_HMO_31_1_PDF from "../pdfs/E01-HMO-31-1.pdf";
import E01_HMO_31_2_PDF from "../pdfs/E01-HMO-31-2.pdf";
import E01_HMO_32_1_PDF from "../pdfs/E01-HMO-32-1.pdf";
import E01_HMO_32_2_PDF from "../pdfs/E01-HMO-32-2.pdf";
import E01_HMO_33_1_PDF from "../pdfs/E01-HMO-33-1.pdf";
import E01_HMO_33_2_PDF from "../pdfs/E01-HMO-33-2.pdf";
import E01_HMO_34_1_PDF from "../pdfs/E01-HMO-34-1.pdf";
import E01_HMO_34_2_PDF from "../pdfs/E01-HMO-34-2.pdf";
import E01_HMO_35_1_PDF from "../pdfs/E01-HMO-35-1.pdf";
import E01_HMO_35_2_PDF from "../pdfs/E01-HMO-35-2.pdf";
import E01_HMO_36_1_PDF from "../pdfs/E01-HMO-36-1.pdf";
import E01_HMO_36_2_PDF from "../pdfs/E01-HMO-36-2.pdf";
import E01_HMO_38_1_PDF from "../pdfs/E01-HMO-38-1.pdf";
import E01_HMO_38_2_PDF from "../pdfs/E01-HMO-38-2.pdf";
import E01_HMO_54_1_PDF from "../pdfs/E01-HMO-54-1.pdf";
import E01_HMO_54_2_PDF from "../pdfs/E01-HMO-54-2.pdf";
import E01_HMO_60_1_PDF from "../pdfs/E01-HMO-60-1.pdf";
import E01_HMO_60_2_PDF from "../pdfs/E01-HMO-60-2.pdf";

export const billboardLocations = [
  {
    id: 0,
    location: { lat: 29.080464, lng: -110.958505 },
    image: Image310,
    code: "MARK-HMO-310",
    size: "11.3 x 7.6 MTS",
    pdf: MARK_HMO_310_PDF,
  },
  {
    id: 1,
    location: { lat: 29.10087, lng: -110.915803 },
    image: Image309,
    code: "MARK-HMO-309",
    size: "11 x 7 MTS",
    pdf: MARK_HMO_309_PDF,
  },
  {
    id: 2,
    location: { lat: 29.0853, lng: -110.990778 }, // Iguales
    image: Image52,
    code: "MARK-HMO-52",
    size: "12.00 x 3.6 MTS",
    pdf: MARK_HMO_52_PDF,
  },
  {
    id: 3,
    location: { lat: 29.0853, lng: -110.990778 }, // Iguales
    image: Image53,
    code: "MARK-HMO-53",
    size: "12.00 x 3.6 MTS",
    pdf: MARK_HMO_53_PDF,
  },
  {
    id: 4,
    location: { lat: 29.085694, lng: -110.969315 }, // Iguales
    image: Image311,
    code: "MARK-HMO-311",
    size: "12.90 x 7.2 MTS",
    pdf: MARK_HMO_311_PDF,
  },
  {
    id: 5,
    location: { lat: 29.085694, lng: -110.969315 }, // Iguales
    image: Image312,
    code: "MARK-HMO-312",
    size: "12.90 x 7.2 MTS",
    pdf: MARK_HMO_312_PDF,
  },
  {
    id: 6,
    location: { lat: 29.054002, lng: -110.963594 },
    image: Image300,
    code: "MARK-HMO-300",
    size: "10.00 x 6.0 MTS",
    pdf: MARK_HMO_300_PDF,
  },
  {
    id: 7,
    location: { lat: 29.103411, lng: -110.992506 },
    image: Image302,
    code: "MARK-HMO-302",
    size: "12.00 x 4 MTS",
    pdf: MARK_HMO_302_PDF,
  },
  {
    id: 8,
    location: { lat: 29.094411, lng: -111.006607 },
    image: Image301,
    code: "MARK-HMO-301",
    size: "12.00 x 6.0 MTS",
    pdf: MARK_HMO_301_PDF,
  },
  {
    id: 9,
    location: { lat: 29.123056, lng: -110.98863 }, // Iguales
    image: Image303,
    code: "MARK-HMO-303",
    size: "12.00 x 6.0 MTS",
    pdf: MARK_HMO_303_PDF,
  },
  {
    id: 10,
    location: { lat: 29.123056, lng: -110.98863 }, // Iguales
    image: Image304,
    code: "MARK-HMO-304",
    size: "12.00 x 3.0 MTS",
    pdf: MARK_HMO_304_PDF,
  },
  {
    id: 11,
    location: { lat: 29.110669, lng: -110.966312 },
    image: Image306,
    code: "MARK-HMO-306",
    size: "12.00 x 4 MTS",
    pdf: MARK_HMO_306_PDF,
  },
  {
    id: 12,
    location: { lat: 29.11324, lng: -110.970788 },
    image: Image305,
    code: "MARK-HMO-305",
    size: "9.00 x 6.0 MTS",
    pdf: MARK_HMO_305_PDF,
  },
  {
    id: 13,
    location: { lat: 29.178233, lng: -110.885201 }, // Iguales
    image: Image307,
    code: "MARK-SNP-307",
    size: "6.00 x 7.0 MTS",
    pdf: MARK_SNP_307_PDF,
  },
  {
    id: 14,
    location: { lat: 29.178233, lng: -110.885201 }, // Iguales
    image: Image308,
    code: "MARK-SNP-308",
    size: "6.00 x 7.0 MTS",
    pdf: MARK_SNP_308_PDF,
  },
  {
    id: 15,
    location: {
      lat: 29.0976663,
      lng: -110.9447897,
    },
    image: Image011,
    code: "E01-HMO-01-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_01_1_PDF,
  },
  {
    id: 16,
    location: {
      lat: 29.0976663,
      lng: -110.9447897,
    },
    image: Image012,
    code: "E01-HMO-01-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_01_2_PDF,
  },
  {
    id: 17,
    location: {
      lat: 22.7708555,
      lng: -102.5832426,
    },
    image: Image02,
    code: "E01-HMO-02",
    size: "12.00 X 6 .50",
    pdf: E01_HMO_02_PDF,
  },
  {
    id: 18,
    location: {
      lat: 20.5837952,
      lng: -103.3887853,
    },
    image: Image061,
    code: "E01-HMO-06-1",
    size: "12.00 X 7 .50",
    pdf: E01_HMO_06_1_PDF,
  },
  {
    id: 19,
    location: {
      lat: 20.5837952,
      lng: -103.3887853,
    },
    image: Image062,
    code: "E01-HMO-06-2",
    size: "12.00 X 7 .50",
    pdf: E01_HMO_06_2_PDF,
  },
  {
    id: 20,
    location: {
      lat: 29.1075349,
      lng: -110.9923053,
    },
    image: Image081,
    code: "E01-HMO-08-1",
    size: "9.00 X 6.00",
    pdf: E01_HMO_08_1_PDF,
  },
  {
    id: 21,
    location: {
      lat: 29.1075349,
      lng: -110.9923053,
    },
    image: Image082,
    code: "E01-HMO-08-2",
    size: "8.00 X 7.00",
    pdf: E01_HMO_08_2_PDF,
  },
  {
    id: 22,
    location: {
      lat: 29.0988163,
      lng: -110.984671,
    },
    image: Image101,
    code: "E01-HMO-10-1",
    size: "6.00 X 7.00",
    pdf: E01_HMO_10_1_PDF,
  },
  {
    id: 23,
    location: {
      lat: 29.0988163,
      lng: -110.984671,
    },
    image: Image102,
    code: "E01-HMO-10-2",
    size: "6.00 X 7.00",
    pdf: E01_HMO_10_2_PDF,
  },
  {
    id: 24,
    location: {
      lat: 29.0687051,
      lng: -110.997414,
    },
    image: Image121,
    code: "E01-HMO-12-1",
    size: "10.00 X 5.00",
    pdf: E01_HMO_12_1_PDF,
  },
  {
    id: 25,
    location: {
      lat: 29.084573,
      lng: -110.957572,
    },
    image: Image191,
    code: "E01-HMO-19-1",
    size: "12.00 X 4.00",
    pdf: E01_HMO_19_1_PDF,
  },
  {
    id: 26,
    location: {
      lat: 29.084573,
      lng: -110.957572,
    },
    image: Image192,
    code: "E01-HMO-19-2",
    size: "12.00 X 4.00",
    pdf: E01_HMO_19_2_PDF,
  },
  {
    id: 27,
    location: {
      lat: 29.091291,
      lng: -111.040749,
    },
    image: Image261,
    code: "E01-HMO-26-1",
    size: "12.00 X 7.50",
    pdf: E01_HMO_26_1_PDF,
  },
  {
    id: 28,
    location: {
      lat: 29.091291,
      lng: -111.040749,
    },
    image: Image262,
    code: "E01-HMO-26-2",
    size: "12.00 X 7.50",
    pdf: E01_HMO_26_2_PDF,
  },
  {
    id: 29,
    location: {
      lat: 29.083258,
      lng: -110.951264,
    },
    image: Image391,
    code: "E01-HMO-39-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_39_1_PDF,
  },
  {
    id: 30,
    location: {
      lat: 29.083258,
      lng: -110.951264,
    },
    image: Image392,
    code: "E01-HMO-39-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_39_2_PDF,
  },
  {
    id: 31,
    location: {
      lat: 29.1327656,
      lng: -110.9525469,
    },
    image: Image401,
    code: "E01-HMO-40-1",
    size: "12.00 X 8.00 ",
    pdf: E01_HMO_40_1_PDF,
  },
  {
    id: 32,
    location: {
      lat: 29.1327656,
      lng: -110.9525469,
    },
    image: Image402,
    code: "E01-HMO-40-2",
    size: "12.00 X 8.00 ",
    pdf: E01_HMO_40_2_PDF,
  },
  {
    id: 33,
    location: {
      lat: 29.153778,
      lng: -110.909754,
    },
    image: Image441,
    code: "E01-HMO-44-1",
    size: "12.00 X 4.00",
    pdf: E01_HMO_44_1_PDF,
  },
  {
    id: 34,
    location: {
      lat: 29.153778,
      lng: -110.909754,
    },
    image: Image442,
    code: "E01-HMO-44-2",
    size: "12.00 X 4.00",
    pdf: E01_HMO_44_2_PDF,
  },
  {
    id: 35,
    location: {
      lat: -12.1311771,
      lng: -76.9902022,
    },
    image: Image471,
    code: "E01-HMO-47-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_47_1_PDF,
  },
  {
    id: 36,
    location: {
      lat: -12.1311771,
      lng: -76.9902022,
    },
    image: Image472,
    code: "E01-HMO-47-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_47_2_PDF,
  },
  {
    id: 37,
    location: {
      lat: 29.097763,
      lng: -110.94487,
    },
    image: Image481,
    code: "E01-HMO-48-1",
    size: "12.00 X 5.50",
    pdf: E01_HMO_48_1_PDF,
  },
  {
    id: 38,
    location: {
      lat: 29.097763,
      lng: -110.94487,
    },
    image: Image482,
    code: "E01-HMO-48-2",
    size: "12.00 X 5.50",
    pdf: E01_HMO_48_2_PDF,
  },
  {
    id: 39,
    location: {
      lat: 29.1107759,
      lng: -110.9510303,
    },
    image: Image501,
    code: "E01-HMO-50-1",
    size: "12.90 x 7.20",
    pdf: E01_HMO_50_1_PDF,
  },
  {
    id: 40,
    location: {
      lat: 29.1107759,
      lng: -110.9510303,
    },
    image: Image502,
    code: "E01-HMO-50-2",
    size: "12.90 x 7.20",
    pdf: E01_HMO_50_2_PDF,
  },
  {
    id: 41,
    location: {
      lat: 29.0944443,
      lng: -111.0023557,
    },
    image: Image511,
    code: "E01-HMO-51-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_51_1_PDF,
  },
  {
    id: 42,
    location: {
      lat: 29.0944443,
      lng: -111.0023557,
    },
    image: Image512,
    code: "E01-HMO-51-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_51_2_PDF,
  },
  {
    id: 43,
    location: {
      lat: 29.1380909,
      lng: -110.9951286,
    },
    image: Image521,
    code: "E01-HMO-52-1",
    size: "12.90 X 5.50",
    pdf: E01_HMO_52_1_PDF,
  },
  {
    id: 44,
    location: {
      lat: 29.1380909,
      lng: -110.9951286,
    },
    image: Image522,
    code: "E01-HMO-52-2",
    size: "12.90 X 5.50",
    pdf: E01_HMO_52_2_PDF,
  },
  {
    id: 45,
    location: {
      lat: 29.0374499,
      lng: -110.9583478,
    },
    image: Image531,
    code: "E01-HMO-53-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_53_1_PDF,
  },
  {
    id: 46,
    location: {
      lat: 29.0374499,
      lng: -110.9583478,
    },
    image: Image532,
    code: "E01-HMO-53-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_53_2_PDF,
  },
  {
    id: 47,
    location: {
      lat: 29.105802,
      lng: -110.951282,
    },
    image: Image561,
    code: "E01-HMO-56-1",
    size: "12.90 x 7.20",
    pdf: E01_HMO_56_1_PDF,
  },
  {
    id: 48,
    location: {
      lat: 29.105802,
      lng: -110.951282,
    },
    image: Image562,
    code: "E01-HMO-56-2",
    size: "12.90 x 7.20",
    pdf: E01_HMO_56_2_PDF,
  },
  {
    id: 49,
    location: {
      lat: 29.110234,
      lng: -110.964661,
    },
    image: Image571,
    code: "E01-HMO-57-1",
    size: "12.90 x 5.50 ",
    pdf: E01_HMO_57_1_PDF,
  },
  {
    id: 50,
    location: {
      lat: 29.110234,
      lng: -110.964661,
    },
    image: Image572,
    code: "E01-HMO-57-2",
    size: "12.90 x 5.50 ",
    pdf: E01_HMO_57_2_PDF,
  },
  {
    id: 51,
    location: {
      lat: 29.1446987,
      lng: -110.9892451,
    },
    image: Image591,
    code: "E01-HMO-59-1",
    size: "10.00 x 6.00",
    pdf: E01_HMO_59_1_PDF,
  },
  {
    id: 52,
    location: {
      lat: 29.1446987,
      lng: -110.9892451,
    },
    image: Image592,
    code: "E01-HMO-59-2",
    size: "10.00 x 6.00",
    pdf: E01_HMO_59_2_PDF,
  },
  {
    id: 53,
    location: {
      lat: 27.0727573,
      lng: -109.4437493,
    },
    image: Image611,
    code: "E01-HMO-61-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_61_1_PDF,
  },
  {
    id: 54,
    location: {
      lat: 27.0727573,
      lng: -109.4437493,
    },
    image: Image612,
    code: "E01-HMO-61-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_61_2_PDF,
  },
  {
    id: 55,
    location: {
      lat: 20.6760832,
      lng: -101.3361631,
    },
    image: Image641,
    code: "E01-HMO-64-1",
    size: "12.90 x 7.20",
    pdf: E01_HMO_64_1_PDF,
  },
  {
    id: 56,
    location: {
      lat: 20.6760832,
      lng: -101.3361631,
    },
    image: Image642,
    code: "E01-HMO-64-2",
    size: "12.90 x 7.20",
    pdf: E01_HMO_64_2_PDF,
  },
  {
    id: 57,
    location: {
      lat: 29.0816251,
      lng: -111.0223114,
    },
    image: Image661,
    code: "E01-HMO-66-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_66_1_PDF,
  },
  {
    id: 58,
    location: {
      lat: 29.0816251,
      lng: -111.0223114,
    },
    image: Image662,
    code: "E01-HMO-66-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_66_2_PDF,
  },
  {
    id: 59,
    location: {
      lat: 23.0303212,
      lng: -99.1479371,
    },
    image: Image721,
    code: "E01-HMO-72-1",
    size: "12.00 x 7.20",
    pdf: E01_HMO_72_1_PDF,
  },
  {
    id: 60,
    location: {
      lat: 23.0303212,
      lng: -99.1479371,
    },
    image: Image722,
    code: "E01-HMO-72-2",
    size: "12.00 x 7.20",
    pdf: E01_HMO_72_2_PDF,
  },
  {
    id: 61,
    location: {
      lat: 29.1124495,
      lng: -110.9510218,
    },
    image: Image751,
    code: "E01-HMO-75-1",
    size: "12.90 x 7.20",
    pdf: E01_HMO_75_1_PDF,
  },
  {
    id: 62,
    location: {
      lat: 29.1124495,
      lng: -110.9510218,
    },
    image: Image752,
    code: "E01-HMO-75-2",
    size: "12.90 x 7.20",
    pdf: E01_HMO_75_2_PDF,
  },
  {
    id: 63,
    location: {
      lat: 29.1266094,
      lng: -110.9515003,
    },
    image: Image021,
    code: "E04-HMO-02-1",
    size: "12.00 x 8.00",
    pdf: E01_HMO_31_1_PDF,
  },
  {
    id: 64,
    location: {
      lat: 29.1266094,
      lng: -110.9515003,
    },
    image: Image022,
    code: "E04-HMO-02-2",
    size: "12.00 x 8.00",
    pdf: E01_HMO_31_2_PDF,
  },
  {
    id: 65,
    location: {
      lat: 29.1129545,
      lng: -110.9812135,
    },
    image: Image051,
    code: "E04-HMO-05-1",
    size: "12.00 x 8.00",
    pdf: E01_HMO_32_1_PDF,
  },
  {
    id: 66,
    location: {
      lat: 29.1129545,
      lng: -110.9812135,
    },
    image: Image052,
    code: "E04-HMO-05-2",
    size: "12.00 x 8.00",
    pdf: E01_HMO_32_2_PDF,
  },
  {
    id: 67,
    location: {
      lat: 29.085241,
      lng: -110.957928,
    },
    image: Image031,
    code: "E08-HMO-03-1",
    size: "10.00 X 6.00",
    pdf: E01_HMO_33_1_PDF,
  },
  {
    id: 68,
    location: {
      lat: 29.085241,
      lng: -110.957928,
    },
    image: Image032,
    code: "E08-HMO-03-2",
    size: "10.00 X 6.00",
    pdf: E01_HMO_33_2_PDF,
  },
  {
    id: 69,
    location: {
      lat: 29.1458895,
      lng: -110.953474,
    },
    image: Image011DOS,
    code: "E08-HMO-01-1",
    size: "12.90 x 7.20",
    pdf: E01_HMO_34_1_PDF,
  },
  {
    id: 70,
    location: {
      lat: 29.1458895,
      lng: -110.953474,
    },
    image: Image012DOS,
    code: "E08-HMO-01-2",
    size: "12.90 x 7.20",
    pdf: E01_HMO_34_2_PDF,
  },
  {
    id: 73,
    location: {
      lat: 29.0674055,
      lng: -110.9551791,
    },
    image: Image061DOS,
    code: "E08-HMO-06-1",
    size: "12.90 x 7.20 ",
    pdf: E01_HMO_35_1_PDF,
  },
  {
    id: 74,
    location: {
      lat: 29.0674055,
      lng: -110.9551791,
    },
    image: Image062DOS,
    code: "E08-HMO-06-2",
    size: "12.90 x 7.20 ",
    pdf: E01_HMO_35_2_PDF,
  },
  {
    id: 75,
    location: {
      lat: 29.095022,
      lng: -111.015969,
    },
    image: Image071DOS,
    code: "E08-HMO-07-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_36_1_PDF,
  },
  {
    id: 76,
    location: {
      lat: 29.095022,
      lng: -111.015969,
    },
    image: Image072DOS,
    code: "E08-HMO-07-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_36_2_PDF,
  },
  {
    id: 77,
    location: {
      lat: 29.057476,
      lng: -110.965384,
    },
    image: Image101DOS,
    code: "E08-HMO-10-1",
    size: "12.90 X 7.20",
    pdf: E01_HMO_38_1_PDF,
  },
  {
    id: 78,
    location: {
      lat: 29.057476,
      lng: -110.965384,
    },
    image: Image102DOS,
    code: "E08-HMO-10-2",
    size: "12.90 X 7.20",
    pdf: E01_HMO_38_2_PDF,
  },
  {
    id: 79,
    location: {
      lat: 29.1088886,
      lng: -110.9513472,
    },
    image: Image111,
    code: "E08-HMO-11-1",
    size: "12.90 x 7.20",
    pdf: E01_HMO_60_1_PDF,
  },
  {
    id: 80,
    location: {
      lat: 29.1088886,
      lng: -110.9513472,
    },
    image: Image112,
    code: "E08-HMO-11-2",
    size: "12.90 x 7.20",
    pdf: E01_HMO_60_2_PDF,
  },
  {
    id: 81,
    location: {
      lat: 29.0875643,
      lng: -110.9767219,
    },
    image: Image121DOS,
    code: "E08-HMO-12-1",
    size: "12.90 x 7.20",
    pdf: E01_HMO_54_1_PDF,
  },
  {
    id: 82,
    location: {
      lat: 29.0875643,
      lng: -110.9767219,
    },
    image: Image122,
    code: "E08-HMO-12-2",
    size: "12.90 x 7.20",
    pdf: E01_HMO_54_2_PDF,
  },
  {
    id: 83,
    location: {
      lat: 29.093787,
      lng: -110.955769, // TODO
    },
    image: Image000,
    code: "MARK-HMO",
    size: "11.00 x 4.00",
    pdf: MARK_HMO_000_PDF,
  },
  {
    id: 84,
    location: {
      lat: 29.089659,
      lng: -111.047082,
    },
    image: Image005,
    code: "PMK-HMO-005",
    size: "12.90 x 7.20",
    pdf: PKM_HMO_005_PDF,
  },
  // New locations from CSV
  {
    id: 85,
    location: { lat: 29.085083333333333, lng: -110.95777777777778 },
    image: null,
    code: "MARK-HMO-313",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD RODRIGUEZ  Y PUEBLA V1",
  },
  {
    id: 86,
    location: { lat: 29.085777777777775, lng: -110.95841666666666 },
    image: null,
    code: "MARK-HMO-314",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD RODRIGUEZ  Y PUEBLA V2",
  },
  {
    id: 87,
    location: { lat: 29.083583333333333, lng: -110.97866666666667 },
    image: null,
    code: "MARK-HMO-315",
    size: "12.90 X 7.20",
    pdf: null,
    address: "AV. COLOSIO Y HERRERIAS V1",
  },
  {
    id: 88,
    location: { lat: 29.083583333333333, lng: -110.97866666666667 },
    image: null,
    code: "MARK-HMO-316",
    size: "12.90 X 7.20",
    pdf: null,
    address: "AV. COLOSIO Y HERRERIAS V2",
  },
  {
    id: 89,
    location: { lat: 29.143361111111112, lng: -110.9533888888889 },
    image: null,
    code: "MARK-HMO-317",
    size: "TBD",
    pdf: null,
    address: "BLVD MORELOS Y PROGRESO V1",
  },
  {
    id: 90,
    location: { lat: 29.142166666666665, lng: -110.9535 },
    image: null,
    code: "MARK-HMO-318",
    size: "TBD",
    pdf: null,
    address: "BLVD MORELOS Y PROGRESO V2",
  },
  {
    id: 91,
    location: { lat: 29.097583333333333, lng: -110.94722222222222 },
    image: null,
    code: "MARK-HMO-319",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD KINO Y 5 DE MAYO V1",
  },
  {
    id: 92,
    location: { lat: 29.097583333333333, lng: -110.94608333333333 },
    image: null,
    code: "MARK-HMO-320",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD KINO Y 5 DE MAYO V2",
  },
  {
    id: 93,
    location: { lat: 29.056722222222223, lng: -110.96511111111111 },
    image: null,
    code: "MARK-HMO-321",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD SOLIDARIDAD Y AV. CARLOS BALDERRAMA V1",
  },
  {
    id: 94,
    location: { lat: 29.057861111111112, lng: -110.96558333333334 },
    image: null,
    code: "MARK-HMO-322",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD SOLIDARIDAD Y AV. CARLOS BALDERRAMA V2",
  },
  {
    id: 95,
    location: { lat: 29.09261111111111, lng: -110.97458333333334 },
    image: null,
    code: "MARK-HMO-323",
    size: "12.00 X 8.00",
    pdf: null,
    address: "AV NAYARIT Y LUIS ENCINAS V1",
  },
  {
    id: 96,
    location: { lat: 29.09236111111111, lng: -110.97586111111112 },
    image: null,
    code: "MARK-HMO-324",
    size: "12.00 X 8.00",
    pdf: null,
    address: "AV NAYARIT Y LUIS ENCINAS V2",
  },
  {
    id: 97,
    location: { lat: 29.10863888888889, lng: -110.95127777777778 },
    image: null,
    code: "MARK-HMO-325",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD MORELOS Y PERIFERICO NORTE V1",
  },
  {
    id: 98,
    location: { lat: 29.107722222222225, lng: -110.95105555555556 },
    image: null,
    code: "MARK-HMO-326",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD MORELOS Y PERIFERICO NORTE V2",
  },
  {
    id: 99,
    location: { lat: 29.112444444444446, lng: -110.99236111111111 },
    image: null,
    code: "MARK-HMO-327",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD SOLIDARIDAD Y CAMELIA V1",
  },
  {
    id: 100,
    location: { lat: 29.113444444444447, lng: -110.99252777777778 },
    image: null,
    code: "MARK-HMO-328",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD SOLIDARIDAD Y CAMELIA V2",
  },
  {
    id: 101,
    location: { lat: 29.093805555555555, lng: -110.95580555555556 },
    image: null,
    code: "MARK-HMO-329",
    size: "11.00 X 4.00",
    pdf: null,
    address: "AV. VERACRUZ Y GARCIA SANCHEZ",
  },
  {
    id: 102,
    location: { lat: 29.089527777777775, lng: -111.04783333333333 },
    image: null,
    code: "MARK-HMO-330",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD GARCIA MORALES Y AEROPUERTO V1",
  },
  {
    id: 103,
    location: { lat: 29.089944444444445, lng: -111.04672222222221 },
    image: null,
    code: "MARK-HMO-331",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD GARCIA MORALES Y AEROPUERTO V2",
  },
  {
    id: 104,
    location: { lat: 29.095055555555554, lng: -111.01625 },
    image: null,
    code: "MARK-HMO-332",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD GARCIA MORALES Y LAZARO MERCADO V1",
  },
  {
    id: 105,
    location: { lat: 29.095138888888886, lng: -111.01511111111111 },
    image: null,
    code: "MARK-HMO-333",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD GARCIA MORALES Y LAZARO MERCADO V2",
  },
  {
    id: 106,
    location: { lat: 29.088083333333334, lng: -110.95722222222223 },
    image: null,
    code: "MARK-HMO-334",
    size: "TBD",
    pdf: null,
    address: "BLVD RODRIGUEZ Y COAHUILA V1",
  },
  {
    id: 107,
    location: { lat: 29.08897222222222, lng: -110.95697222222222 },
    image: null,
    code: "MARK-HMO-335",
    size: "TBD",
    pdf: null,
    address: "BLVD RODRIGUEZ Y COAHUILA V2",
  },
  {
    id: 108,
    location: { lat: 29.06813888888889, lng: -110.95533333333334 },
    image: null,
    code: "MARK-HMO-336",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD VILDOSOLA Y PASEO RIO SONORA V1",
  },
  {
    id: 109,
    location: { lat: 29.066583333333334, lng: -110.95486111111111 },
    image: null,
    code: "MARK-HMO-337",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD VILDOSOLA Y PASEO RIO SONORA V2",
  },
  {
    id: 110,
    location: { lat: 29.08811111111111, lng: -110.97844444444445 },
    image: null,
    code: "MARK-HMO-338",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD NAVARRETE Y OLIVARES V1",
  },
  {
    id: 111,
    location: { lat: 29.088166666666666, lng: -110.97936111111112 },
    image: null,
    code: "MARK-HMO-339",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD NAVARRETE Y OLIVARES V2",
  },
  {
    id: 112,
    location: { lat: 29.088833333333334, lng: -110.9568888888889 },
    image: null,
    code: "MARK-HMO-340",
    size: "TBD",
    pdf: null,
    address: "BLVD RODRIGUEZ Y GARMENDIA",
  },
  {
    id: 113,
    location: { lat: 29.08063888888889, lng: -110.95841666666666 },
    image: null,
    code: "MARK-HMO-341",
    size: "11.30 X 7.60",
    pdf: null,
    address: "BLVD COLOSIO Y ROSALES",
  },
  {
    id: 114,
    location: { lat: 29.101083333333335, lng: -110.91605555555556 },
    image: null,
    code: "MARK-HMO-342",
    size: "11.00 X 7.00",
    pdf: null,
    address: "BLVD ENRIQUE MAZON Y ROSARIO IBARRA",
  },
  {
    id: 115,
    location: { lat: 29.08533333333333, lng: -110.99066666666667 },
    image: null,
    code: "MARK-HMO-343",
    size: "12.00 X 3.60",
    pdf: null,
    address: "BLVD COLOSIO Y PASEO LAS QUINTAS V1",
  },
  {
    id: 116,
    location: { lat: 29.085055555555556, lng: -110.99158333333334 },
    image: null,
    code: "MARK-HMO-344",
    size: "12.00 X 3.60",
    pdf: null,
    address: "BLVD COLOSIO Y PASEO LAS QUINTAS V2",
  },
  {
    id: 117,
    location: { lat: 29.08588888888889, lng: -110.9695 },
    image: null,
    code: "MARK-HMO-345",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD NAVARRETE Y 14 DE ABRIL V1",
  },
  {
    id: 118,
    location: { lat: 29.085666666666665, lng: -110.97002777777777 },
    image: null,
    code: "MARK-HMO-346",
    size: "12.90 X 7.20",
    pdf: null,
    address: "BLVD NAVARRETE Y 14 DE ABRIL V2",
  },
  {
    id: 119,
    location: { lat: 29.05375, lng: -110.96352777777778 },
    image: null,
    code: "MARK-HMO-347",
    size: "10.00 X 6.00",
    pdf: null,
    address: "BLVD SOLIDARIDAD Y AV DEL FUERTE V1",
  },
  {
    id: 120,
    location: { lat: 29.104166666666668, lng: -110.99244444444444 },
    image: null,
    code: "MARK-HMO-348",
    size: "12.00 X 4.00",
    pdf: null,
    address: "BLVD SOLIDARIDAD Y SATURNINO CAMPOY V1",
  },
  {
    id: 121,
    location: { lat: 29.103472222222223, lng: -110.99275 },
    image: null,
    code: "MARK-HMO-349",
    size: "12.00 X 4.00",
    pdf: null,
    address: "BLVD SOLIDARIDAD Y SATURNINO CAMPOY V2",
  },
  {
    id: 122,
    location: { lat: 29.094666666666665, lng: -111.00672222222222 },
    image: null,
    code: "MARK-HMO-350",
    size: "12.00 X 6.00",
    pdf: null,
    address: "BLVD QUINTERO ARCE Y GARCIA MORALES",
  },
  {
    id: 123,
    location: { lat: 29.122583333333335, lng: -110.98875 },
    image: null,
    code: "MARK-HMO-351",
    size: "12.00 X 6.00",
    pdf: null,
    address: "CALLE MAZA DE JUAREZ ESQ BLVD LAZARO CARDENAS",
  },
  {
    id: 124,
    location: { lat: 29.123083333333334, lng: -110.98858333333334 },
    image: null,
    code: "MARK-HMO-352",
    size: "12.00 X 3.00",
    pdf: null,
    address: "CALLE MAZA DE JUAREZ ESQ BLVD LAZARO CARDENAS",
  },
  {
    id: 125,
    location: { lat: 29.110833333333336, lng: -110.96627777777778 },
    image: null,
    code: "MARK-HMO-353",
    size: "12.00 X 4.00",
    pdf: null,
    address: "PERIFERICO NORTE ESQ GRAL. PIÑA",
  },
  {
    id: 126,
    location: { lat: 29.137583333333332, lng: -110.99494444444444 },
    image: null,
    code: "MARK-HMO-354",
    size: "12.90 X 5.50",
    pdf: null,
    address: "BLVD SOLIDARIDAD Y SUAQUI GRANDE",
  },
  {
    id: 127,
    location: { lat: 29.109972222222222, lng: -110.96308333333333 },
    image: null,
    code: "MARK-HMO-355",
    size: "12.90 X 5.50",
    pdf: null,
    address: "PERIFERICO NORTE Y REYES",
  },
  {
    id: 128,
    location: { lat: 29.108944444444447, lng: -110.94866666666667 },
    image: null,
    code: "MARK-HMO-356",
    size: "12.00 X 7.20 *",
    pdf: null,
    address: "BLVD IGNACIO SOTO Y GOMEZ FARIAS",
  },
  {
    id: 129,
    location: { lat: 29.118305555555555, lng: -111.02355555555556 },
    image: null,
    code: "MARK-HMO-357",
    size: "12.00 X 7.50 *",
    pdf: null,
    address: "BLVD QUIROGA Y NAVOJOA",
  },
  {
    id: 130,
    location: { lat: 29.11325, lng: -110.97091666666667 },
    image: null,
    code: "MARK-HMO-358",
    size: "9.00 X 6.00",
    pdf: null,
    address: "CALLE REFORMA Y BLVD LAZARO CARDENAS",
  },
  {
    id: 131,
    location: { lat: 29.12302777777778, lng: -110.95100000000001 },
    image: null,
    code: "MARK-HMO-359",
    size: "12.00 X 8.00",
    pdf: null,
    address: "BLVD MORELOS Y LOPEZ PORTILLO V1",
  },
  {
    id: 132,
    location: { lat: 29.124472222222224, lng: -110.95116666666667 },
    image: null,
    code: "MARK-HMO-360",
    size: "12.00 X 8.00",
    pdf: null,
    address: "BLVD MORELOS Y LOPEZ PORTILLO V2",
  },
  {
    id: 133,
    location: { lat: 29.178194444444447, lng: -110.8846388888889 },
    image: null,
    code: "MARK-SNP-307",
    size: "6.00 X 7.00",
    pdf: null,
    address: "CARRETERA FERDERAL 14 SAN PEDRO EL SAUCITO V1",
  },
  {
    id: 134,
    location: { lat: 29.178194444444447, lng: -110.88566666666668 },
    image: null,
    code: "MARK-SNP-308",
    size: "6.00 X 7.00",
    pdf: null,
    address: "CARRETERA FERDERAL 14 SAN PEDRO EL SAUCITO V2",
  },
  {
    id: 135,
    location: { lat: 27.49475, lng: -109.93047222222222 },
    image: null,
    code: "MARK-OBR-01",
    size: "12.00 X 8.00",
    pdf: null,
    address: "BLVD MIGUEL ALEMAN CD OBREGON V1",
  },
  {
    id: 136,
    location: { lat: 27.496166666666667, lng: -109.93047222222222 },
    image: null,
    code: "MARK-OBR-02",
    size: "12.00 X 8.00",
    pdf: null,
    address: "BLVD MIGUEL ALEMAN CD OBREGON V2",
  },
  {
    id: 137,
    location: { lat: 31.297, lng: -110.95272222222222 },
    image: null,
    code: "MARK-NGL-01",
    size: "12.00 X 4.00",
    pdf: null,
    address: "BLVD COLOSIO NOGALES V1",
  },
  {
    id: 138,
    location: { lat: 31.297444444444444, lng: -110.95313888888889 },
    image: null,
    code: "MARK-NGL-02",
    size: "12.00 X 4.00",
    pdf: null,
    address: "BLVD COLOSIO NOGALES V2",
  },
];
